





























































import Vue from 'vue'

export default Vue.extend({
  components: {},
  props: [
    'activatorText',
    'title',
    'action',
    'actionDisabled',
    'large',
    'noLimitWidth',
    'disabled',
    'icon',
    'hint',
    'value',
  ],
  data: () => ({
    dialog: false,
  }),
  watch: {
    dialog() {
      this.$emit('dialog', this.dialog)
    },
  },
  methods: {
    actionClick() {
      this.dialog = false
      this.$emit('action')
    },
    evalSize() {
      if (this.noLimitWidth) {
        return 'default'
      } else {
        return this.large ? '900' : '600'
      }
    },
  },
})
